export default {
  id: "averageUnitsPerTransaction",
  name: "",
  description: "",
  report: {
    name: "AVG Units per Transaction",
    chartType: "NUMBER",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Sale",
      dimensions: [],
      measures: ["Sale.avg_units_per_transaction"],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "1",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
